import API from 'files/api.js';

// Google reCAPTCHA (score-based key from the Google Cloud console) for the
// public forms.
//
// It runs invisibly: forms call load() when they appear so Google can observe
// the visit, then getToken(action) when submitting. The server creates an
// assessment for the token, checks it was generated for the same action, and
// rejects low scores. Tokens are single use and expire after two minutes, so a
// fresh one is requested for every submission rather than held in state.
const siteKey = () => (API.recaptcha && API.recaptcha.siteKey) || '';

let scriptPromise = null;

const load = () => {
    if(!scriptPromise) {
        scriptPromise = new Promise((resolve, reject) => {
            // a blocked script may never report back, so give up after a while rather than leaving the form waiting
            const timeout = setTimeout(() => onError(), 10000);
            const whenReady = () => window.grecaptcha.enterprise.ready(() => {
                clearTimeout(timeout);
                resolve(window.grecaptcha.enterprise);
            });
            const onError = () => {
                clearTimeout(timeout);
                scriptPromise = null;
                reject(new Error('Unable to load verification. Please refresh and try again.'));
            };

            // the script may already be on the page, either loaded or still loading from a tag in index.html
            if(window.grecaptcha && window.grecaptcha.enterprise) {
                whenReady();
                return;
            }
            let script = document.querySelector('script[src*="recaptcha/enterprise.js"]');
            if(!script) {
                script = document.createElement('script');
                script.src = `https://www.google.com/recaptcha/enterprise.js?render=${encodeURIComponent(siteKey())}`;
                script.async = true;
                document.head.appendChild(script);
            }
            script.addEventListener('load', whenReady);
            script.addEventListener('error', onError);
        });
    }
    return scriptPromise;
};

const getToken = async (action) => {
    const grecaptcha = await load();
    return grecaptcha.execute(siteKey(), { action: action });
};

const Captcha = {
    getToken: getToken,
    load: load
};

export default Captcha;
